import { useGameStore } from '@/store/gameStore'
import { PageShell } from '../components/PageShell'
import { PageTabs } from '../components/PageTabs'
import { FeatureGate } from '../components/FeatureGate'
import { FEATURES } from '@/config/clubLevelConfig'
import { TournamentsTabContent } from '../panels/TournamentsTab'
import { LeagueTabContent } from '../panels/LeagueTab'
import { CircuitTabContent } from '../panels/CircuitTab'
import { Trophy, Shield, Globe } from 'lucide-react'

export function CompetitionsPage() {
  const activeTournament = useGameStore(s => s.activeTournament)
  const tournamentsCompleted = useGameStore(s => s.tournamentsCompleted)

  return (
    <PageShell
      pageId="competitions"
      title="Competición"
      subtitle={`${tournamentsCompleted} torneos completados${activeTournament ? ' · 1 en curso' : ''}`}
      icon={<Trophy size={22} />}
    >
      <PageTabs
        variant="broadcast"
        tabs={[
          {
            label: 'Liga',
            icon: <Shield size={16} />,
            content: <FeatureGate feature={FEATURES.LEAGUE}><LeagueTabContent /></FeatureGate>,
          },
          {
            label: 'Torneos',
            icon: <Trophy size={16} />,
            content: <TournamentsTabContent />,
          },
          {
            label: 'Circuito',
            icon: <Globe size={16} />,
            content: <FeatureGate feature={FEATURES.LEAGUE}><CircuitTabContent /></FeatureGate>,
          },
        ]}
      />
    </PageShell>
  )
}
